import Header from '../course/components/Header';
import Footer from '../course/components/Footer';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      <main className="container mx-auto px-6 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms of Service</h1>
            
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-600 mb-8">
                <strong>Last Updated:</strong> December 2024
              </p>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptance of Terms</h2>
                <p className="text-gray-700">
                  By accessing and using the Georgia Dealer License Course and related services provided by Premier Capital Holdings ("we," "us," or "our"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Description of Service</h2>
                <p className="text-gray-700 mb-4">
                  We provide educational content and resources related to obtaining a Georgia used car dealer license, including:
                </p>
                <ul className="list-disc pl-6 text-gray-700">
                  <li>Online video course modules</li>
                  <li>Downloadable templates and checklists</li>
                  <li>Email support and guidance</li>
                  <li>Consultation services</li>
                  <li>Resource library and tools</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Payment and Refund Policy</h2>
                <p className="text-gray-700 mb-4">
                  <strong>Payment:</strong> Payment is required before accessing premium course content. We accept major credit cards through our secure payment processor.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong>No Refunds:</strong> All sales are final. We do not offer refunds for any reason after purchase. We encourage you to review the free preview content and course outline thoroughly before making your purchase decision.
                </p>
                <p className="text-gray-700">
                  <strong>Payment Plans:</strong> If you choose a payment plan option, you agree to make payments according to the specified schedule. Failure to make payments may result in suspension of access to course materials.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Course Access and Usage</h2>
                <p className="text-gray-700 mb-4">
                  <strong>Lifetime Access:</strong> Upon purchase, you receive lifetime access to the course content and any future updates.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong>Personal Use Only:</strong> The course content is for your personal use only. You may not share, distribute, or resell any part of the course materials.
                </p>
                <p className="text-gray-700">
                  <strong>Account Security:</strong> You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Intellectual Property</h2>
                <p className="text-gray-700 mb-4">
                  All content, including but not limited to text, graphics, logos, images, audio clips, video clips, digital downloads, and software, is the property of Premier Capital Holdings and is protected by copyright laws.
                </p>
                <p className="text-gray-700">
                  You may not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the material on our website without our prior written consent.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Disclaimers and Limitations</h2>
                <p className="text-gray-700 mb-4">
                  <strong>Educational Purpose:</strong> Our course is for educational purposes only. We do not guarantee that following our course will result in obtaining a dealer license.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong>No Legal Advice:</strong> The information provided is not legal advice. You should consult with qualified professionals for specific legal, financial, or business advice.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong>Regulatory Changes:</strong> Licensing requirements and regulations may change. While we strive to keep our content current, you are responsible for verifying current requirements with official sources.
                </p>
                <p className="text-gray-700">
                  <strong>Results Not Guaranteed:</strong> Individual results may vary. Success depends on many factors including your effort, compliance with requirements, and external circumstances beyond our control.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Limitation of Liability</h2>
                <p className="text-gray-700">
                  In no event shall Premier Capital Holdings be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of the service.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">8. User Conduct</h2>
                <p className="text-gray-700 mb-4">
                  You agree not to:
                </p>
                <ul className="list-disc pl-6 text-gray-700">
                  <li>Use the service for any unlawful purpose</li>
                  <li>Share your account credentials with others</li>
                  <li>Attempt to gain unauthorized access to our systems</li>
                  <li>Interfere with or disrupt the service</li>
                  <li>Upload or transmit viruses or malicious code</li>
                  <li>Violate any applicable laws or regulations</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Privacy</h2>
                <p className="text-gray-700">
                  Your privacy is important to us. Please review our Privacy Policy, which also governs your use of the service, to understand our practices.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Termination</h2>
                <p className="text-gray-700">
                  We may terminate or suspend your access to the service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Changes to Terms</h2>
                <p className="text-gray-700">
                  We reserve the right to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days notice prior to any new terms taking effect.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Governing Law</h2>
                <p className="text-gray-700">
                  These Terms shall be interpreted and governed by the laws of the State of Georgia, without regard to its conflict of law provisions.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">13. Contact Information</h2>
                <p className="text-gray-700 mb-4">
                  If you have any questions about these Terms of Service, please contact us:
                </p>
                <div className="bg-gray-50 p-6 rounded-lg">
                  <p className="text-gray-700 mb-2">
                    <strong>Email:</strong> Info@gerogiadealerlicense.com
                  </p>
                  <p className="text-gray-700 mb-2">
                    <strong>Company:</strong> Premier Capital Holdings
                  </p>
                  <p className="text-gray-700">
                    <strong>Subject Line:</strong> Terms of Service Inquiry
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}